var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClearNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50781 7.25L13.0234 3.73438C13.4805 3.3125 13.4805 2.60938 13.0234 2.1875L12.25 1.41406C11.8281 0.957031 11.125 0.957031 10.7031 1.41406L7.1875 4.92969L3.63672 1.41406C3.21484 0.957031 2.51172 0.957031 2.08984 1.41406L1.31641 2.1875C0.859375 2.60938 0.859375 3.3125 1.31641 3.73438L4.83203 7.25L1.31641 10.8008C0.859375 11.2227 0.859375 11.9258 1.31641 12.3477L2.08984 13.1211C2.51172 13.5781 3.21484 13.5781 3.63672 13.1211L7.1875 9.60547L10.7031 13.1211C11.125 13.5781 11.8281 13.5781 12.25 13.1211L13.0234 12.3477C13.4805 11.9258 13.4805 11.2227 13.0234 10.8008L9.50781 7.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClearNotificationIcon);
export default __webpack_public_path__ + "static/media/white-clear-notification-icon.88e473520982a94aa1b561c6d95aaa3a.svg";
export { ForwardRef as ReactComponent };